import { Component, Input } from '@angular/core';
import {
  CeiBreadcrumbsComponent,
  CeiBreadcrumbsConfig,
  CeiButtonComponent,
} from '@cei-ufg/ngx-arquitetura-cei-frontend';
import { montarTrilhaAdmin } from '../admin-trilha.utils';

/** Posição do botão Voltar em relação ao título e à trilha de navegação. */
export type AdminPosicaoVoltar = 'acima-titulo' | 'trilha';

/**
 * Cabeçalho de páginas internas do admin: trilha opcional com Voltar à direita, ou Voltar acima do título.
 */
@Component({
  selector: 'cei-admin-page-cabecalho',
  standalone: true,
  imports: [CeiBreadcrumbsComponent, CeiButtonComponent],
  templateUrl: './admin-page-cabecalho.component.html',
  styleUrl: './admin-page-cabecalho.component.scss',
  host: {
    '[class.admin-page-cabecalho--com-trilha]': 'temTrilha',
  },
})
export class AdminPageCabecalhoComponent {
  /** Título exibido abaixo da trilha ou do link Voltar. */
  @Input({ required: true }) titulo!: string;

  /** Destino do botão Voltar (listagem ou detalhe). */
  @Input() rotaVoltar: string | readonly unknown[] | null = null;

  /**
   * Primeiro chip (listagem). Omitido = usa `rotaVoltar`.
   * Na edição, listagem aqui e detalhe em `rotaVoltar`.
   */
  @Input() rotaLista: string | readonly unknown[] | null = null;

  /**
   * `trilha`: Voltar à direita dos breadcrumbs (trilha automática a partir de `titulo` + `rotaVoltar`, salvo `trilha` explícita).
   * `acima-titulo`: Voltar alinhado à direita acima do título (comportamento anterior).
   */
  @Input() posicaoVoltar: AdminPosicaoVoltar = 'trilha';

  /** Configuração explícita da trilha; sobrescreve a montagem automática. */
  @Input() trilha: CeiBreadcrumbsConfig | null = null;

  /** Rótulo do item de listagem na trilha; padrão derivado de `rotaLista`/`rotaVoltar`. */
  @Input() rotuloLista: string | null = null;

  /** Rótulo do chip de detalhe quando `rotaLista` e `rotaVoltar` diferem. */
  @Input() rotuloDetalhe: string | null = null;

  /** Indica se a trilha será renderizada (espaço toolbar→conteúdo sobe para o shell). */
  protected get temTrilha(): boolean {
    return this.trilhaResolvida() != null;
  }

  /** Trilha efetiva quando `posicaoVoltar` é `trilha`. */
  protected trilhaResolvida(): CeiBreadcrumbsConfig | null {
    if (this.posicaoVoltar !== 'trilha') {
      return null;
    }

    if (!this.rotaVoltar && !this.rotaLista && !this.trilha?.level1) {
      return null;
    }

    const lista = this.rotaLista ?? this.rotaVoltar;
    const detalhe = this.rotaLista ? this.rotaVoltar : null;

    return montarTrilhaAdmin(
      this.titulo,
      lista,
      this.trilha,
      this.rotuloLista,
      detalhe,
      this.rotuloDetalhe,
    );
  }
}
